/**
 * @module websocket.event.handlers.airlines.airline-list-updated
 */
import { store } from '../../../../state/store'
import { setAirlineListUpdated } from '../../../../state/websocket.slice'

export default function handleAirlineListUpdated(context) {
  const { payload: { channelId, data } = {} } = context
  if (!data || !channelId) {
    return
  }

  const isSubscribed = store
    .getState()
    ?.websocket?.subscriptions?.some((channel) => channel === channelId)

  if (isSubscribed) {
    store.dispatch(setAirlineListUpdated(data))
  }
} 